import React from 'react'
import './PaymentCard.scss';
const PaymentCard = (props) => {
    const paymentPlanData = props.paymentPlanData;
    return (
        <div className='d-md-flex flex-wrap justify-content-between'>
            {
                paymentPlanData.map((item, index) => {
                    return <div key={index} className="payment-plan">
                        <h4>{item.installation}</h4>
                        <span className='data-card'>{item.installationInfo}</span>
                    </div>
                })
            }
        </div>
    )
}

export default PaymentCard



